const carouselItems = [
  {
    id: 1,
    title: '2026暑期档必看大片',
    desc: '香蕉视频精选暑期档热门电影，动作、科幻、喜剧一网打尽，高清画质畅享影院级体验',
    tag: '暑期特辑',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20collection%20showcase%20with%20warm%20dramatic%20lighting%2C%20movie%20posters%20collage%20style%2C%20rich%20contrast%2C%20golden%20and%20deep%20red%20tones%2C%20professional%20cinema%20aesthetic%2C%20clean%20composition&width=600&height=450&seq=carousel-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '国产悬疑剧天花板',
    desc: '红桃视频高分悬疑剧集大盘点，烧脑剧情层层反转，每一部都让人欲罢不能',
    tag: '悬疑精选',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20collection%20showcase%20with%20warm%20dramatic%20lighting%2C%20movie%20posters%20collage%20style%2C%20rich%20contrast%2C%20golden%20and%20deep%20red%20tones%2C%20professional%20cinema%20aesthetic%2C%20clean%20composition&width=600&height=450&seq=carousel-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '经典港片高清修复',
    desc: '蜜桃视频独家呈现经典港片高清修复版，重温黄金时代的银幕魅力',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20collection%20showcase%20with%20warm%20dramatic%20lighting%2C%20movie%20posters%20collage%20style%2C%20rich%20contrast%2C%20golden%20and%20deep%20red%20tones%2C%20professional%20cinema%20aesthetic%2C%20clean%20composition&width=600&height=450&seq=carousel-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '全网综艺热度排行',
    desc: '91视频热门综艺实时更新，搞笑、竞技、生活类综艺应有尽有，总有一款适合你',
    tag: '综艺热榜',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20collection%20showcase%20with%20warm%20dramatic%20lighting%2C%20movie%20posters%20collage%20style%2C%20rich%20contrast%2C%20golden%20and%20deep%20red%20tones%2C%20professional%20cinema%20aesthetic%2C%20clean%20composition&width=600&height=450&seq=carousel-4-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">精选优质影视专题，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {carouselItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">{item.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}